(function () {
    'use strict';

    angular
        .module('tikonApp')
        .controller('BankAccountInfoDialogController', BankAccountInfoDialogController);

    BankAccountInfoDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'BankAccountInfo'];

    function BankAccountInfoDialogController($timeout, $scope, $stateParams, $uibModalInstance, entity, BankAccountInfo) {
        var vm = this;

        vm.bankAccountInfo = entity;
        vm.clear = clear;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.save = save;

        $timeout(function () {
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        function save() {
            vm.isSaving = true;
            if (vm.bankAccountInfo.id !== null) {
                BankAccountInfo.update(vm.bankAccountInfo, onSaveSuccess, onSaveError);
            } else {
                BankAccountInfo.save(vm.bankAccountInfo, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess(result) {
            $scope.$emit('tikonApp:bankAccountInfoUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError() {
            vm.isSaving = false;
        }

        vm.datePickerOpenStatus.createDate = false;

        function openCalendar(date) {
            vm.datePickerOpenStatus[date] = true;
        }
    }
})();
